<div
  class="formContainer"
>
  <div
    class="formInputsSectionStyle"
  >
    <div
      class='inputLabelContainer'
    >
      <input
        class='inputStyle'
        placeholder=' '
        [id]="identifiersSet.ratingName"
        (focus)="textInputFocusHandler($event)"
        (blur)="textInputBlurHandler($event)"
        [(ngModel)]="ratingName"
        maxlength="200"
      >
      <label
        class='labelStyle'
        (click)='labelClickHandler($event)'
      >
        {{labelsSet.ratingName}}
      </label>
      <div
        *ngIf="errorLabelFlags[identifiersSet.ratingName]"
        class="errorMessageStyle"
      >
        {{getCertainErrorMessage(identifiersSet.ratingName)}}
      </div>
    </div>
    <div
      class="customSelectAndErrorWrapper"
    >
      <div
        class="customSelectWrapper"
      >
        <app-custom-select
          [wholeElementId]="identifiersSet.ratingStatus"
          [labelText]="labelsSet.ratingStatus"
          [optionsList]="getRatingStatusesList()"
          [externalStyles]="customStylesSelect"
          [optionTransformer]="optionsTransformersSet.ratingStatus"
          [(selectedOption)]="selectedStatus"
          (onOpen)="onOpen($event, identifiersSet.ratingStatus)"
        >
        </app-custom-select>
      </div>
      <div
        *ngIf="errorLabelFlags[identifiersSet.ratingStatus]"
        class="errorMessageStyle"
      >
        {{getCertainErrorMessage(identifiersSet.ratingStatus)}}
      </div>
    </div>
    <div
      class="inputLabelContainer"
    >
      <input
        class='inputStyle'
        placeholder=' '
        [id]="identifiersSet.country"
        (focus)="textInputFocusHandler($event)"
        (blur)="textInputBlurHandler($event)"
        [ngbTypeahead]="searchCountry"
        [resultFormatter]="typeAheadDataTransformers.countryResultFormatter"
        [inputFormatter]="typeAheadDataTransformers.countryInputFormatter"
        (selectItem)="typeAheadSelectHandlers.countrySelect($event)"
        [ngModel]="valuesToDisplayForTypeAhead.country"
        [disabled]="countryDisabled()"
        #instance="ngbTypeahead"
        [editable]="false"
        popupClass="searchResultsDropdownList"
      >
      <label
        class='labelStyle'
        (click)='labelClickHandler($event)'
        [ngClass]="inactiveLabelStyle(countryDisabled())"
      >
        {{labelsSet.country}}
      </label>
      <div
        *ngIf="errorLabelFlags[identifiersSet.country] && !countryDisabled()"
        class="errorMessageStyle"
      >
        {{getCertainErrorMessage(identifiersSet.country)}}
      </div>
    </div>
    <div
      class="inputLabelContainer"
    >
      <input
        class='inputStyle'
        placeholder=' '
        [id]="identifiersSet.city"
        [ngbTypeahead]="searchCity"
        [resultFormatter]="typeAheadDataTransformers.cityResultFormatter"
        [inputFormatter]="typeAheadDataTransformers.cityInputFormatter"
        (focus)="textInputFocusHandler($event)"
        #instance="ngbTypeahead"
        (blur)="textInputBlurHandler($event)"
        (selectItem)="typeAheadSelectHandlers.citySelect($event)"
        [ngModel]="valuesToDisplayForTypeAhead.city"
        [disabled]="cityDisabled()"
        [editable]="false"
        popupClass="searchResultsDropdownList"
      >
      <label
        class='labelStyle'
        (click)='labelClickHandler($event)'
        [ngClass]="inactiveLabelStyle(cityDisabled())"
      >
        {{labelsSet.city}}
      </label>
      <div
        *ngIf="errorLabelFlags[identifiersSet.city] && !cityDisabled()"
        class="errorMessageStyle"
      >
        {{getCertainErrorMessage(identifiersSet.city)}}
      </div>
    </div>
    <div
      class="customSelectAndErrorWrapper"
    >
      <div
        class="customSelectWrapper"
      >
        <app-custom-select
          [wholeElementId]="identifiersSet.game"
          [labelText]="labelsSet.game"
          [optionsList]="getGameTypesList()"
          [externalStyles]="customStylesSelect"
          [optionTransformer]="optionsTransformersSet.gameType"
          [(selectedOption)]="selectedGameType"
          (onOpen)="onOpen($event, identifiersSet.game)"
        >
        </app-custom-select>
      </div>
      <div
        *ngIf="errorLabelFlags[identifiersSet.game]"
        class="errorMessageStyle"
      >
        {{getCertainErrorMessage(identifiersSet.game)}}
      </div>
    </div>
  </div>


  <div class='formTournamentsSearchStyle'>
    <div
      class="inputLabelContainer"
    >
      <input
        class='inputStyle'
        placeholder=' '
        [id]='identifiersSet.tournaments'
        (focus)="textInputFocusHandler($event)"
        (blur)="textInputBlurHandler($event)"
        [ngbTypeahead]="searchTournament"
        [resultFormatter]="typeAheadDataTransformers?.tournamentResultFormatter"
        [inputFormatter]="typeAheadDataTransformers?.tournamentInputFormatter"
        (selectItem)="typeAheadSelectHandlers.tournamentSelect($event)"
        #instance="ngbTypeahead"
        popupClass="searchResultsDropdownList"
      >
      <label
        class='labelStyle'
        (click)='labelClickHandler($event)'
      >
        {{labelsSet.tournaments}}
      </label>
    </div>

    <div
      *ngIf="!noTournamentsWereSelected()"
      class="selectedTournamentsSection"
    >
      <div
        class="selectedTournamentsHeader"
      >
        {{selectedTournamentsHeader}}
      </div>
      <div class="selectedTournamentsList">
        <div
          *ngFor="let tournament of tournamentsListToDisplay; index as i"
          class="selectedTournament"
        >
          <div
            [ngClass]="tournamentStyleOnHover(i)"
          >
            {{tournament?.name}}
          </div>
          <div>
            <div
              class="iconButtonSection"
              (click)="onTournamentDelete(i)"
            >
              <mat-icon
                (mouseover)="setIndexOnHover(i)"
                (mouseout)="clearIndexOnHover()"
              >
                close
              </mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
